import styled from "@emotion/styled";
import { useLocation } from "react-router";

import { SvgInteractLogoSmallText } from "@skilitics/designer-theme";
import { BUTTON_HEIGHT, FONT_WEIGHT_SEMI_BOLD, Icon, LinkButton } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";

const HeaderPrefixContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 10px;
`;

const Logo = styled(SvgInteractLogoSmallText)`
  color: ${({ theme }) => (theme.type === "light" ? theme.generalTextIcon : theme.alwaysWhite)};
  height: ${BUTTON_HEIGHT}px;
  width: auto;
`;

const HoverText = styled.div`
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
  color: ${({ theme }) => theme.primary};
  transition: all 0.2s ease-in-out;
  padding: 4px 12px;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const StyledLink = styled(LinkButton)`
  transition: all 0.2s ease-in-out;
  position: relative;
  border-radius: ${({ theme }) => theme.borderRadius}px;
  border: 1px solid transparent;
  padding: 2px 0;
  svg {
    transition: all 0.2s ease-in-out;
    margin-left: -1px;
  }
  &:hover {
    border-color: ${({ theme }) => theme.primary};
    > svg {
      opacity: 0;
    }
    ${HoverText} {
      opacity: 1;
    }
  }
`;

export const HeaderPrefix = () => {
  const { pathname } = useLocation();
  const formatMessage = useFormatMessage(formatStrings);

  return (
    <HeaderPrefixContainer>
      {pathname.indexOf("modules/create") < 0 && pathname.indexOf("modules/") > -1 && (
        <StyledLink to="/modules">
          <Logo />
          <HoverText>
            <Icon faPrefix="fas" icon="caret-left" /> {formatMessage("home")}
          </HoverText>
        </StyledLink>
      )}
    </HeaderPrefixContainer>
  );
};

const formatStrings = {
  home: {
    en: "Dashboard",
  },
};
